// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Important: This imports your global Kinetix CSS
import App from './App'; // Important: This imports your main App component

// Get the root element from public/index.html
const root = ReactDOM.createRoot(document.getElementById('root'));

// Render the main App component
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Note: We removed the import and call for reportWebVitals.